import PubSub from "underpub-js";

var CardFeature = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardFeature',
	};

	$.extend(true, this.options, options);

};

CardFeature.prototype.init = function() {

	var self = this;

};

export default CardFeature;
